<template>
	<div
		class="flex-grow flex flex-col justify-between w-full md:w-3/5 xl:w-2/3 focus-within:relative md:relative bg-gray-150"
	>
		<div
			class="sticky top-[8.5rem] md:top-0 flex-grow bg-gray-600 md:mx-2 flex gap-x-4 md:rounded-b-2xl border-w-full items-center text-gray-300 px-4 py-3 lg:py-4 md:pb-6"
			v-if="showContactInfo"
		>
			<div class="w-1/2 text-gray-200">
				<h3 class="text-2xl md:text-4xl font-semibold">
					{{ thread.counterpart.name }}
				</h3>
				<p>{{ thread.counterpart.company_name }}</p>
			</div>

			<div class="w-1/2 flex flex-col space-y-3 gap-x-4 my-2">
				<div class="flex space-x-4 items-center">
					<ui-icon
						class="h-5 w-5 text-gray-400 flex-shrink-0"
						name="mail"
						stroke-width="2"
					/>
					<span class="truncate">{{ thread.counterpart.email_manager }}</span>
				</div>
				<div class="flex space-x-4 items-center" v-if="canShowMoreInfo">
					<ui-icon
						class="h-5 w-5 text-gray-400 flex-shrink-0"
						name="phone"
						stroke-width="2"
					/>
					<span>{{ telephoneString }}</span>
				</div>
				<div
					class="flex space-x-4 items-center"
					v-if="canShowMoreInfo && thread.counterpart.tel_alternate"
				>
					<ui-icon
						class="h-5 w-5 text-gray-400 flex-shrink-0"
						name="phone"
						stroke-width="2"
					/>
					<span>{{ thread.counterpart.tel_alternate }}</span>
				</div>
				<div class="flex space-x-4 items-center">
					<ui-icon
						class="h-5 w-5 text-gray-400 flex-shrink-0"
						name="home"
						stroke-width="2"
					/>
					<span>{{ addressString }}</span>
				</div>

				<ul
					class="flex flex-col space-y-3 gap-x-4"
					v-if="counterpartUploads.length > 0"
				>
					<li
						class="flex space-x-4 items-center truncate"
						v-for="(upload, idx) in counterpartUploads"
						:key="'UPLOAD_' + idx"
					>
						<ui-icon
							class="h-5 w-5 text-gray-400 flex-shrink-0"
							name="file"
							stroke-width="2"
						/>
						<a
							target="_blank"
							class="underline"
							:href="$route('user_upload.download', { id: upload.id })"
							>{{ getUploadLabel(upload) }}</a
						>
					</li>
				</ul>
			</div>
		</div>

		<!-- use flex-col-reverse justify-end h-full to have the last message at the bottom focused/scrolled to -->
		<!-- https://stackoverflow.com/questions/69035823/tailwind-scroll-to-bottom-on-page-load-or-new-line -->

		<div
			id="thread-view-events"
			class="flex-grow md:overflow-y-auto flex w-full h-full space-y-6 flex-col NOTflex-col-reverse px-4 sm:px-6 lg:px-6 pt-4 lg:pt-6 pb-6 md:pb-28"
		>
			<thread-show-event
				v-for="event in threadEvents"
				:key="event.id"
				:thread="thread"
				:event="event"
				:isLast="isLast(event)"
				:counterpartUploads="counterpartUploads"
				ref="showEvent"
			/>

			<!-- required for scrolling position
            <div id="last-item"></div>-->
		</div>

		<thread-show-post
			:thread="thread"
			class="sticky bottom-0 md:absolute w-full focus-within:absolute focus-within:bottom-[0%]"
		/>
	</div>
</template>

<script>
export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
		showListOnMobile: {
			type: Boolean,
			required: false,
		},
		showContactInfo: {
			type: Boolean,
			required: false,
		},
	},
	data: function () {
		let that = this;
		return {
			threadEvents: [],
			counterpartUploads: [],
			markReadTimer: setTimeout(function () {
				return that.markRead();
			}, 3 * 1000),
			showSearch: false,
			uploadOpen: false,
			test: "",
		};
	},
	async created() {
		let endpoint = window.baseUrl + "/api/user_upload/",
			resp = await axios.get(endpoint, {
				params: {
					user_id: this.thread.counterpart.id,
				},
			});
		this.counterpartUploads = resp.data.data;
	},
	watch: {
		thread: {
			immediate: true,
			handler: function (newThread) {
				this.threadEvents = newThread.events;
			},
			deep: true,
		},
	},
	computed: {
		counterpartName: function () {
			return this.thread.counterpart.company_name;
		},
		addressString() {
			let address = this.thread.counterpart.address;
			if (address) {
				return `${address.street}, ${address.zip} ${address.city}`;
			} else {
				return this.__("Not specified");
			}
		},
		telephoneString() {
			return this.thread.counterpart.tel_mobile || this.__("Not specified");
		},
		canShowMoreInfo() {
			return (this.thread.contracts ?? []).length > 0;
		},
	},
	methods: {
		getUploadLabel(upload) {
			return this.__(upload.label_id ?? upload.label ?? upload.filename);
		},
		scrollToBottom: function () {
			// scroll to most recent event

			console.log("scrollToBottom");
			let that = this;
			this.$nextTick(() => {
				let lastEvent = (that.$refs.showEvent || []).slice(-1)[0];
				console.log("scrollToBottom", lastEvent);
				if (lastEvent) {
					lastEvent.$el.scrollIntoView();
				}
				/*
                let container = document.getElementById("thread-view-events");
                container.scrollTop = container.scrollHeight;

                // https://stackoverflow.com/questions/11715646/scroll-automatically-to-the-bottom-of-the-page
                window.scrollTo(0, document.body.scrollHeight);
                */
			});
		},
		markRead() {
			if (document.hasFocus()) {
				let that = this,
					markReadUrl =
						window.baseUrl + "/api/thread/" + that.thread.id + "/mark_read";
				axios.post(markReadUrl).then(function (resp) {
					that.$bus.$emit("thread-update", resp.data.data);
				});
			}
		},
		uploadUrl(upload) {
			return window.baseUrl + "/api/user_upload/" + upload.id + "/download";
		},
		updateThread(threadId) {
			console.log("need update for ", threadId);
			let that = this,
				z = window.baseUrl + "/api/thread/" + threadId;
			axios.get(z).then(function (resp) {
				that.$bus.$emit("thread-update", resp.data.data);
			});
		},
		toggleUpload() {
			this.uploadOpen = !this.uploadOpen;
			setTimeout(() => {
				/* update ? */
				document.getElementById("thread").scrollTop =
					document.getElementById("last-item").offsetTop;
			});
		},
		isLast(event) {
			if (event.type == "BID") {
				return event.bid_id == this.thread.last_tradable.id;
			} else if (event.type == "CONTRACT") {
				return event.contract_id == this.thread.last_tradable.id;
			}
			return false;
		},
	},
	updated() {
		this.scrollToBottom();
	},
	mounted() {
		let that = this;
		this.$bus.$on("thread-needs-update", function (threadId) {
			if (threadId == that.thread.id) {
				that.updateThread(threadId);
			}
		});

		this.updateThread(this.thread.id);
		this.scrollToBottom();
	},
	beforeDestroy() {
		clearTimeout(this.markReadTimer);
	},
};
</script>

<style scoped>
.thread-post-message-textarea {
	width: calc(100% - 55px) !important;
} /* do not perform such calculations within components as the magical 55px depend on other stylings */

.list-group-flush :last-child {
	border-bottom: none;
}
</style>
